import axios from 'axios';
import env from '../configs/env';
import { toast } from 'react-toastify';
import { validateJwtToken } from '../services/auth.services';
const axiosInstance = axios.create({
    baseURL: env.ApiUrl,
    headers: {
        'content-type': 'application/json; charset=utf-8'
    }
});

function getAccessToken() {
    return localStorage.getItem('accessToken');
}
function getRefreshToken() {
    return localStorage.getItem('refreshToken');
}

axiosInstance.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        let accessToken = getAccessToken();
        if (accessToken) {
            config.headers = {
                ...config.headers,
                Authorization: `Bearer ${accessToken}`
            };
        }
        if (config.url === 'auth/logout') {
            localStorage.clear();
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);
function showError(object: object) {
    console.log('object', object);
    let entries: [string, [string]][] = Object.entries(object);
    let errorCollection = entries.map((item) => {
        return item[1][0];
    });
    console.log('Error Collections', errorCollection);
}

async function handleError(err: any) {
    const originalreq = err.config;
    console.log(originalreq);
    ///TODO: Handle 403
    if (err.response.status === 401) {
        ///TODO:Handle retry logic
        let user = validateJwtToken(getAccessToken());
        console.log('user', user);
        axiosInstance.post('/auth/refresh', { userId: user?.id, refreshToken: getRefreshToken() }).then((res) => {
            localStorage.setItem('accessToken', res.data.data.token);
            window.location.reload();
        });
        //return RefreshToken(err);
    } else if (err.response.status === 400) {
        //console.log('errors', err.response.data.errors);
        // if (err.response.data.errors.length > 0) {
        //     console.log(showError(err.response.data.errors));
        // } else {
        toast.error(err.response.data.message);
        //}
        ///TODO:Handle retry logic
        //return RefreshToken(err);
    } else {
        if (err.response.data && (err.response.data.error || err.response.data.Error)) {
            if (err.response.data.error !== undefined) showError(err.response.data.error);
            else showError(err.response.data.Error);
            //Error(formHtml);
        }
    }
}

axiosInstance.interceptors.response.use(function (response) {
    console.log('intercepter response', response);
    if (response.config.url === 'auth/login' && response.status === 200) {
        let user = validateJwtToken(response.data.accessToken);
        let isPlatformAdmin = user?.Role.find((role) => role.name === 'Platform Admin');
        if (typeof isPlatformAdmin === undefined) {
            return Promise.reject({ code: 401 });
        }
        localStorage.setItem('accessToken', response.data.data.accessToken);
        localStorage.setItem('refreshToken', response.data.data.refreshToken);
    }
    if (response.config.url === 'auth/logout' && response.status === 200) {
        localStorage.clear();
    }
    //console.log(response);
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
});

let err = axiosInstance.interceptors.response.use(undefined, async (err) => {
    await handleError(err);
    return Promise.reject(err.response.data);
});

axiosInstance.interceptors.request.eject(err);

export default axiosInstance;
